import styled from 'styled-components';
import { black, blue, border1, exactWhite } from 'utils/style/colors';

export const TaskAttachmentBox = styled('div')`
  display: flex;
  cursor: pointer;
  height: 5.5rem;
  width: 24.5rem;
  @media (max-width: 500px) {
    width: 20rem;
  }
`;

export const TaskAttachmentText = styled('div')`
  overflow: hidden;
  display: block;
  text-wrap: nowrap;
  text-overflow: clip;
  max-width: 17rem;
`;

export const TaskAttachmentContent = styled('div')`
  display: inline-flex;
  flex: 1;
  border: ${border1};
  border-radius: 20px;
  align-items: center;
`;

export const TaskAttachmentRemoveIconHolder = styled('div')`
  width: 40px;
  line-height: 60px;
  align-self: center;
`;

// Task Attachment container
export const TaskAttachmentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
`;

// Task Icon attachment
export const TaskIconAttachments = styled.div`
  width: 50%;
  background-image: ${(props) =>
    `linear-gradient(to ${props.theme.direction === 'rtl' ? 'left' : 'right'}, ${blue} 0%, ${exactWhite} 100%)`};
  color: var(--exact-white);
  border-radius: 20px;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: start;
  padding-inline-start: 1rem;
`;

export const TaskContentAttachment = styled.div`
  height: 100%;

  width: 100%;
  @media (max-width: 500px) {
    width: unset;
  }
  flex-grow: 1;
  border-radius: 20px;
  background: var(--exact-white);
  padding: 0.8rem 1rem;
  margin-inline-start: ${(props) => (props.editable ? '-5.25rem' : '-6.25rem')};
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${black};
  border-right: 1px solid #e0e0e0;
`;

export const FileNameAttachment = styled.div`
  /* text-align: center; */
  /* flex-grow: 1; */
  margin: 0.75rem 0;
  font-weight: bold;
  align-self: flex-start;
`;
export const FileInfomationAttachment = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
export const FileInfomationAttachmentItem = styled.div`
  ${(props) => props.type === 'date' && 'flex-shrink:0'}
`;
